export const or = (...predicates) => {
  return (traffic) => {
    return predicates.some((predicate) => {
      return predicate(traffic);
    });
  };
};
